import { render, staticRenderFns } from "./Flows.vue?vue&type=template&id=3ed0345f&scoped=true&lang=pug&"
import script from "./Flows.vue?vue&type=script&lang=js&"
export * from "./Flows.vue?vue&type=script&lang=js&"
import style0 from "./Flows.vue?vue&type=style&index=0&id=3ed0345f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed0345f",
  null
  
)

export default component.exports